module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"loading":"Chargement...","noNotif":"Aucune notification reçue"},"en":{"loading":"Loading...","noNotif":"No notification received"}}')
  delete Component.options._Ctor
}
